var map = {
	"./blog-details.png": 1214,
	"./blog-grid.png": 5906,
	"./blog-two-column.png": 3143,
	"./hero-bg.jpg": 3135,
	"./home-01.png": 2500,
	"./home-02.png": 7775,
	"./logo-2.png": 9595,
	"./logo.png": 7410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1335;